'use client';

import { DateTime } from 'luxon';
import { dropdown } from './CustomDateRange.css';
import { es } from 'date-fns/locale';
import { useLocale } from '@instamenu/context-i18n';
import { DatePicker } from '@instamenu/ui-system-next';
import { Timespan } from '../core/forms/timespans';

type CustomDateRangeProps = {
  onChange: (value: Timespan) => void;
  timespan: Timespan;
};

export default function CustomDateRange({ onChange, timespan }: CustomDateRangeProps) {
  const { i18n } = useLocale();

  const handleDayClick = (day: Date) => {
    const from = timespan.start.toJSDate();
    const to = timespan.end.toJSDate();

    const dayDate = DateTime.fromJSDate(day);
    if (!dayDate.isValid) return;

    if (day > from && day > to) {
      onChange({ ...timespan, end: dayDate });
    } else if (day < from) {
      onChange({ ...timespan, start: dayDate });
    } else if (day < to && day > from) {
      onChange({ ...timespan, end: dayDate });
    } else {
      onChange({ ...timespan, start: dayDate, end: dayDate });
    }
  };

  // if there is a new locale, add to this object.
  const locales = { es };
  const equalLocale = i18n.locale.split('-')[0];
  const dateFnsLocale = locales[equalLocale as keyof typeof locales];

  return (
    <div className={dropdown}>
      <DatePicker
        defaultMonth={timespan.start.toJSDate()}
        locale={dateFnsLocale}
        selected={{ from: timespan.start.toJSDate(), to: timespan.end.toJSDate() }}
        onDayClick={handleDayClick}
        mode="range"
      />
    </div>
  );
}
